<div class="app-wrapper">
  <div class="app-content">
    <router-outlet />
  </div>
  <app-footer></app-footer>
</div>
<app-toast-container />
